import { useQuery } from '@tanstack/react-query'
import type { HostEngineAssociations } from '@sbclite/core/container/api'
import { api } from '../services/api'

export const hostEngineAssociationQueryKeys = {
  engines: (hostId: string, userId: string | undefined) => ['host-engine-associations', hostId, userId ?? 'anonymous'] as const,
} as const

export function useHostEngineAssociations(hostId: string | undefined, userId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: hostEngineAssociationQueryKeys.engines(hostId ?? '', userId),
    queryFn: async (): Promise<HostEngineAssociations> => (await api.getHostEngineAssociations(hostId ?? '')).data,
    enabled: enabled && !!hostId,
  })
}
